import { render, staticRenderFns } from "./ConfigModal.vue?vue&type=template&id=0d857cb9"
import script from "./ConfigModal.vue?vue&type=script&lang=js"
export * from "./ConfigModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports